import { GET_SECTOR, GET_SECTOR_ERROR, GET_SECTOR_SUCCESS } from './SectorSection.actions'

const sectorsSectionState = {
  amount: 0,
  amountUSD: 0,
  biddings: 0,
  error: undefined,
  id: undefined,
  loading: false,
  name: '',
  orders: 0,
  organizations: 0,
  purchases: 0
}

/**
 * The sector section's reducer.
 */
const sectorSectionReducer = (state = sectorsSectionState, { payload, type }) => {
  switch (type) {
    case GET_SECTOR: {
      return { ...state, loading: true }
    }
    case GET_SECTOR_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_SECTOR_SUCCESS: {
      return { ...state, ...payload, loading: false }
    }
    default: {
      return state
    }
  }
}

export default sectorSectionReducer
